var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',_vm._b({class:[
    ("text-" + _vm.color),
    {
      'text-xl': _vm.large,
      'text-2xl': _vm.xLarge,
      'text-4xl': _vm.xxLarge,
      'mr-2': _vm.left
    }
  ],attrs:{"icon":[_vm.type, _vm.name]}},'font-awesome-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }